document.addEventListener('DOMContentLoaded', () => {
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
  
    dropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const parent = toggle.closest('.menu-item');
  
        // Cerrar otros dropdowns
        document.querySelectorAll('.menu-item.open').forEach(openItem => {
          if (openItem !== parent) {
            openItem.querySelector('.dropdown-toggle').setAttribute('aria-expanded', 'false');
          }
        });
  
        // Alternar el estado del dropdown actual
        const isOpen = parent.classList.toggle('open');
        toggle.setAttribute('aria-expanded', isOpen);
      });
    });
  });
  